<template>
  <div class="interest-free-activity">
    <div v-if="!isChildPage">
      <SpFilterForm :model="searchForm" size="small" @onSearch="handleSearch" @onReset="handleReset">
        <SpFilterFormItem prop="activityName">
          <el-input
            v-model="searchForm.activityName"
            placeholder="活动名称"
            clearable
          />
        </SpFilterFormItem>
        <SpFilterFormItem prop="activityId">
          <el-input
            v-model="searchForm.activityId"
            placeholder="活动ID"
            clearable
          />
        </SpFilterFormItem>
      </SpFilterForm>

      <div v-if="isDistiAdmin" class="list-toolbar">
        <el-button type="primary" size="medium" @click="handleAdd">添加免息分期活动</el-button>
      </div>

      <SpFinder
        :key="activeTab"
        ref="finder"
        :row-key="rowKey"
        :url="tableUrl"
        :setting="setting"
        fixed-row-action
        no-selection
        :split-count="10"
        :hooks="{
          beforeSearch,
          afterSearch
        }"
      >
        <template #tableTop>
          <div class="table-top">
            <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
              <el-tab-pane
                v-for="item in StatusOption"
                :key="item.value"
                :label="item.label"
                :name="item.value"
              />
            </el-tabs>
          </div>
        </template>
      </SpFinder>

      <DealerViewDialog v-model="dealerDialogVisible" :activity="currentRow" />
      <GoodsViewDialog v-model="goodsDialogVisible" :activity="currentRow" />
    </div>
    <router-view />
  </div>
</template>

<script>
import { StatusOption, tableSetting, draftTableSetting } from './config'
import { List, DraftList, onlineActivity, offlineActivity, createDraftActivity, deleteDraft } from './api'
import { IS_DISTI_ADMIN } from '@/utils'
import DealerViewDialog from './comps/dealer-view-dialog'
import GoodsViewDialog from './comps/goods-view-dialog'

export default {
  name: 'InterestFreeActivity',
  components: {
    DealerViewDialog,
    GoodsViewDialog
  },
  data () {
    return {
      StatusOption,
      tableUrl: List,
      activeTab: 'all',
      searchForm: {
        activityName: '',
        activityId: ''
      },
      currentRow: {},
      dealerDialogVisible: false,
      goodsDialogVisible: false
    }
  },
  computed: {
    isDistiAdmin () {
      return IS_DISTI_ADMIN()
    },
    isChildPage () {
      return this.$route.path.indexOf('_operation') !== -1
        || this.$route.path.indexOf('_subsidyflow') !== -1
    },
    isDraftTab () {
      return this.activeTab === 'draft'
    },
    rowKey () {
      return this.isDraftTab ? 'draft_id' : 'activity_id'
    },
    setting () {
      return this.isDraftTab ? draftTableSetting(this) : tableSetting(this)
    }
  },
  methods: {
    buildSearchQuery (params = {}) {
      const query = {
        page: params.page,
        pageSize: params.pageSize,
        activity_name: this.searchForm.activityName || ''
      }
      if (!this.isDraftTab && this.activeTab !== 'all') {
        query.status = this.activeTab
      }
      if (this.searchForm.activityId) {
        query.activity_id = this.searchForm.activityId
      }
      return query
    },
    beforeSearch (params) {
      return this.buildSearchQuery(params)
    },
    afterSearch (res) {
      const { data } = res.data
      return data
    },
    refresh (resetPage) {
      this.$refs.finder.refresh(resetPage)
    },
    handleSearch () {
      this.refresh(true)
    },
    handleReset () {
      this.searchForm = {
        activityName: '',
        activityId: ''
      }
      this.refresh(true)
    },
    handleTabClick () {
      this.tableUrl = this.isDraftTab ? DraftList : List
    },
    switchTab (tab) {
      const exists = this.StatusOption.some(item => item.value === tab)
      if (!exists || this.activeTab === tab) return
      this.activeTab = tab
      this.tableUrl = tab === 'draft' ? DraftList : List
    },
    handleAdd () {
      this.$router.push({ path: this.matchHidePage('operation') })
    },
    handleOnline (row) {
      this.$confirm('确定上架该活动？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await onlineActivity(row.activity_id)
          const data = res.data.data || {}
          const { success_count = 0, failed_count = 0, processed = 0 } = data
          if (failed_count > 0) {
            this.$message.warning(`上架完成，成功 ${success_count} 家，失败 ${failed_count} 家`)
          } else if (processed > 0) {
            this.$message.success(`活动已上架，${processed} 家经销商正在异步处理`)
          } else {
            this.$message.success(`上架成功，成功 ${success_count} 家`)
          }
          this.refresh()
        } catch (e) {
          const msg = (e.response && e.response.data && e.response.data.message) || e.message || '上架失败'
          this.$message.error(msg)
        }
      }).catch(() => {})
    },
    handleOffline (row) {
      this.$confirm('确定下架该活动？下架后将不允许再次上架。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await offlineActivity(row.activity_id)
          const data = res.data.data || {}
          const { success_count = 0, failed_count = 0 } = data
          if (failed_count > 0) {
            this.$message.warning(`下架完成，成功 ${success_count} 家，失败 ${failed_count} 家`)
          } else {
            this.$message.success(`下架成功，成功 ${success_count} 家`)
          }
          this.refresh()
        } catch (e) {
          const msg = (e.response && e.response.data && e.response.data.message) || e.message || '下架失败'
          this.$message.error(msg)
        }
      }).catch(() => {})
    },
    handleAction (action, row) {
      this.currentRow = row
      if (action === 'edit') {
        this.$router.push({
          path: this.matchHidePage('operation'),
          query: { id: row.activity_id }
        })
        return
      }
      if (action === 'viewDealer') {
        this.dealerDialogVisible = true
        return
      }
      if (action === 'viewGoods') {
        this.goodsDialogVisible = true
        return
      }
      if (action === 'viewSubsidy') {
        this.$router.push({
          path: this.matchHidePage('subsidyflow'),
          query: {
            id: row.activity_id,
            activity_name: row.activity_name
          }
        })
        return
      }
      if (action === 'publish') {
        this.handleOnline(row)
        return
      }
      if (action === 'unpublish') {
        this.handleOffline(row)
        return
      }
      if (action === 'draftEdit') {
        this.$router.push({
          path: this.matchHidePage('operation'),
          query: { draft_id: row.draft_id }
        })
        return
      }
      if (action === 'draftCreate') {
        this.handleDraftCreate(row)
        return
      }
      if (action === 'draftDelete') {
        this.handleDraftDelete(row)
      }
    },
    async handleDraftCreate (row) {
      try {
        await createDraftActivity(row.draft_id)
        this.$message.success('创建成功')
        this.switchTab('all')
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message || '创建失败'
        this.$message.error(msg)
      }
    },
    handleDraftDelete (row) {
      this.$confirm('确定删除该草稿？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteDraft(row.draft_id)
          this.$message.success('已删除')
          this.refresh()
        } catch (e) {
          const msg = (e.response && e.response.data && e.response.data.message) || e.message || '删除失败'
          this.$message.error(msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.interest-free-activity {
  .list-toolbar {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 12px;
  }

  .table-top {
    margin-bottom: 4px;
  }
}

::v-deep .sp-finder .cell .sp-finder-actions__wrap {
  justify-content: flex-start !important;
}
</style>
